<script setup>
// Cambios:
// - Eliminado prop rolJuez — con un solo juez no hay rol activo/standby
// - Eliminado badge "Observador" / "Juez activo"
// - Simplificado: el header solo muestra tatami, pelea actual, estado WS y botón salir
defineProps({
  tatamiId: { type: [String, Number], default: 1 },
  wsConectado: { type: Boolean, default: false },
  peleaActual: { type: Object, default: null },
});
defineEmits(["salir"]);
</script>

<template>
  <header class="tatami-header">
    <div class="header-left">
      <a href="/" class="logo">
        <img
          src="../../assets/img/Evolve/EGPro.png"
          alt="EGPro"
          style="max-height: 44px"
        />
      </a>
      <span class="tatami-label">Tatami {{ tatamiId }}</span>
    </div>

    <div class="header-center" v-if="peleaActual">
      <span class="chip round"
        >R{{ peleaActual.ronda }} · P{{ peleaActual.numero_pelea }}</span
      >
      <span class="chip cat">{{ peleaActual.categoria || "—" }}</span>
    </div>

    <div class="header-right">
      <div class="ws-status" :class="{ online: wsConectado, offline: !wsConectado }">
        <span class="ws-dot"></span>
        <span class="ws-text">{{ wsConectado ? "En línea" : "Desconectado" }}</span>
      </div>
      <button class="btn-salir" @click="$emit('salir')">Salir</button>
    </div>
  </header>
</template>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Mono:wght@400;500&family=DM+Sans:wght@400;600&display=swap");

.tatami-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: linear-gradient(180deg, #192747, #192747);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
  gap: 12px;
}

/* Left */
.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.logo {
  display: flex;
  align-items: center;
}
.tatami-label {
  font-family: "DM Mono", monospace;
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.85);
}

/* Center */
.header-center {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 2;
  justify-content: center;
  min-width: 0;
}
.chip {
  font-family: "DM Mono", monospace;
  font-size: 11px;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.06);
}
.chip.round {
  background: rgba(56, 189, 248, 0.12);
  border-color: rgba(56, 189, 248, 0.25);
}
.chip.cat {
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Right */
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ws-status {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-family: "DM Mono", monospace;
  font-size: 11px;
  font-weight: 600;
  color: white;
  background: rgba(255, 255, 255, 0.1);
}
.ws-status.online {
  background: #16a34a;
}
.ws-status.offline {
  background: #dc2626;
}
.ws-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.ws-text {
  color: white;
}

.btn-salir {
  padding: 5px 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.25s;
}
.btn-salir:hover {
  background: rgba(212, 43, 26, 0.15);
  border-color: #d42b1a;
  color: #ff5b4a;
}

@media (max-width: 640px) {
  .header-center {
    display: none;
  }
}
</style>
